import { Link } from "react-router-dom";
import { Ticket, Mail, MapPin } from "lucide-react";
import { useSiteImages } from "../../hooks/useSiteImages";

const Footer = () => {
  const { getImage } = useSiteImages();
  return (
    <footer className="bg-[#0F2137] text-white py-16" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img src={getImage("logo")} alt="Lane4" className="h-16 w-auto mb-6 brightness-0 invert" />
            <p className="text-gray-400 leading-relaxed mb-4">
              Your trusted partner for e-ticketing, custom medals, and track & field excellence.
            </p>
            <a 
              href="https://globaletickets.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#D90429] hover:text-white transition-colors text-sm font-medium"
            >
              <Ticket size={16} />
              Powered by Global E-Tickets
            </a>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: "E-Tickets", path: "/e-tickets" },
                { label: "Custom Medals", path: "/medals" },
                { label: "Events", path: "/events" },
                { label: "Merch", path: "/merch" },
                { label: "Reviews", path: "/reviews" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#D90429]" />
                <a href="mailto:info@lane4.org" className="hover:text-white transition-colors">
                  info@lane4.org
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#D90429]" />
                <a href="mailto:sales@lane4.org" className="hover:text-white transition-colors">
                  sales@lane4.org
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D90429] mt-1" />
                <span>PO Box 14076<br />St Petersburg, FL 33733</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Hours</h4>
            <p className="text-gray-400">
              Monday - Friday<br />
              8am - 9pm EST
            </p>
            <div className="mt-6">
              <Link to="/contact" className="btn-outline-white text-sm py-3 px-6 inline-block">
                Get In Touch
              </Link>
            </div>
            <div className="mt-6 space-y-2">
              <a 
                href="https://www.lane4tracking.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-400 hover:text-white transition-colors text-sm"
              >
                Lane4 Tracking
              </a>
              <a 
                href="https://www.lane4foundation.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-400 hover:text-white transition-colors text-sm"
              >
                Lane4 Foundation
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Lane4. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/refund" className="hover:text-white transition-colors">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
